var styles = {
  "InlineStack": "Polaris-InlineStack"
};

export { styles as default };
